import { render, staticRenderFns } from "./trainlist.vue?vue&type=template&id=db4691a8&scoped=true&"
import script from "./trainlist.vue?vue&type=script&lang=js&"
export * from "./trainlist.vue?vue&type=script&lang=js&"
import style0 from "./trainlist.vue?vue&type=style&index=0&id=db4691a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4691a8",
  null
  
)

export default component.exports